module.exports = __webpack_public_path__ + "static/media/pdf-thumbnail.6feb8491.png";